module.exports = __webpack_public_path__ + "img/archive.efb083c8.svg";